import type { RouteVisitShippingFilters } from '../hooks';
import type { RouteShippingFilterOption } from '../utils/route-visit-shipping-filters';

interface FilterRowProps {
  label: string;
  allCount: number;
  options: RouteShippingFilterOption[];
  selectedValue: string | null;
  onSelect: (value: string | null) => void;
  loadingText?: string;
}

const chipClassName = (isSelected: boolean): string =>
  `inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-sm transition-colors ${
    isSelected
      ? 'border-[var(--primary-color)] bg-[var(--primary-color)] text-white'
      : 'border-gray-200 bg-white text-gray-700 hover:border-[var(--primary-color)]'
  }`;

const FilterRow = ({
  label,
  allCount,
  options,
  selectedValue,
  onSelect,
  loadingText,
}: FilterRowProps) => (
  <div className='flex flex-wrap items-center gap-2'>
    <span className='w-32 shrink-0 text-xs font-semibold text-gray-700'>
      {label}
    </span>
    {loadingText ? (
      <span className='text-sm text-gray-500'>{loadingText}</span>
    ) : (
      <>
        <button
          type='button'
          aria-pressed={selectedValue === null}
          className={chipClassName(selectedValue === null)}
          onClick={() => onSelect(null)}
        >
          Todos <span className='font-bold tabular-nums'>{allCount}</span>
        </button>
        {options.map((option) => {
          const isSelected = selectedValue === option.value;
          return (
            <button
              key={option.value || 'sin-valor'}
              type='button'
              aria-pressed={isSelected}
              className={chipClassName(isSelected)}
              onClick={() => onSelect(isSelected ? null : option.value)}
            >
              {option.label}{' '}
              <span className='font-bold tabular-nums'>{option.count}</span>
            </button>
          );
        })}
      </>
    )}
  </div>
);

interface VisitShippingFiltersProps {
  filters: RouteVisitShippingFilters;
}

const VisitShippingFilters = ({ filters }: VisitShippingFiltersProps) => {
  if (filters.totalCount === 0) return null;

  return (
    <div className='mb-4 flex shrink-0 flex-col gap-2'>
      <FilterRow
        label='Estado del pedido'
        allCount={filters.statusRowTotal}
        options={filters.statusOptions}
        selectedValue={filters.selectedStatus}
        onSelect={filters.setSelectedStatus}
        loadingText={
          filters.isLoadingStatuses ? 'Cargando estados…' : undefined
        }
      />
      <FilterRow
        label='Servicio'
        allCount={filters.serviceRowTotal}
        options={filters.serviceOptions}
        selectedValue={filters.selectedService}
        onSelect={filters.setSelectedService}
      />
    </div>
  );
};

export default VisitShippingFilters;
